export default __webpack_public_path__ + "static/media/ga.24fa0979.png";